import { useState, useCallback, useEffect } from "react";
// import { useIdleTimer } from "react-idle-timer";
import { TABLET_MAX_WIDTH_V2 } from "../util/layout";

const AUTO_COLLAPSE_TIMEOUT = 5_000; // 5 seconds

export const useSiderAutoCollapse = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [menuHover, setMenuHover] = useState(false);

  const handleMenuHover = useCallback((value: boolean) => {
    setMenuHover(value);
  }, []);

  const handleCollapse = useCallback((value: boolean) => {
    setCollapsed(value);
  }, []);

  const onSiderItemClick = useCallback(() => {
    setCollapsed(false);
  }, []);

  // Standard timer - collapses after fixed time period regardless of user activity
  // Timer restarts whenever the sidebar is expanded (collapsed becomes false)
  useEffect(() => {
    if (collapsed) {
      // Don't start timer if already collapsed
      return;
    }

    const timer = setTimeout(() => {
      if (window.innerWidth <= TABLET_MAX_WIDTH_V2) {
        // Don't auto-collapse on very large screens
        setCollapsed(true);
      }
    }, AUTO_COLLAPSE_TIMEOUT);

    return () => {
      clearTimeout(timer);
    };
  }, [collapsed]);

  // Idle timer - collapses after period of inactivity (commented out)
  // useIdleTimer({
  //   crossTab: false,
  //   leaderElection: false,
  //   timeout: AUTO_COLLAPSE_TIMEOUT,
  //   syncTimers: 200,
  //   onIdle: () => {
  //     if (window.innerWidth <= TABLET_MAX_WIDTH_V2) { // Don't auto-collapse on very large screens
  //       setCollapsed(true);
  //     }
  //   },
  // });

  return {
    menuHover,
    collapsed,
    handleCollapse,
    handleMenuHover,
    onSiderItemClick,
  };
};
